<template>
	<client-only v-if="isTablet">
		<transition name="fade">
			<button v-show="isButtonShow" class="button button-goPink button-small fixed z-[1] p-8 bottom-24 right-24" @click.prevent="scrollToTop">
				<svg-icon name="arrow-back" class="iconSize-24 rotate-90" />
			</button>
		</transition>
	</client-only>
</template>

<script>
import debounce from "lodash/debounce"

const showButtonBreakpoint = 1000

export default {
	data() {
		return {
			isButtonShow: false,
		}
	},
	computed: {
		isTablet() {
			return this.$store.state.browser.breakpoint.isTablet
		}
	},
	watch: {
		isTablet(newValue) {
			newValue ? this.addScrollEvent() : this.removeScrollEvent()
		}
	},
	mounted() {
		if (this.isTablet) this.addScrollEvent()
	},
	beforeDestroy() {
		this.removeScrollEvent()
	},
	methods: {
		addScrollEvent() {
			this.updateButtonVisibility()
			if (this.debouncedScroll) return
			this.debouncedScroll = debounce(this.updateButtonVisibility, 50)
			window.addEventListener("scroll", this.debouncedScroll)
		},
		removeScrollEvent() {
			if (!this.debouncedScroll) return
			window.removeEventListener("scroll", this.debouncedScroll)
			this.debouncedScroll = null
		},
		updateButtonVisibility() {
			this.isButtonShow = window.scrollY > showButtonBreakpoint
		},
		scrollToTop() {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			this.isButtonShow = false
		},
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity 150ms ease;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>
